import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './app/App'
import './styles/tokens.css'

/**
 * One query client for the app.
 *
 * `staleTime` is deliberately non-zero: the builder reads the same paper from
 * several components, and refetching on every mount would make an editor that
 * flickers. Retries are off for mutations - a failed save must be reported, not
 * quietly attempted again behind the teacher's back.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: false, retry: 1 },
    mutations: { retry: 0 },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
